import Mark from "./Mark.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import MarkText from "../components/MarkText.ts";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class ShortMark extends Mark implements IMark
{
    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this._init();
    }

    private _init():void
    {
        this.markWidth = this.adjustToScale(60);
        this.markHeight = this.adjustToScale(16);
        if(this.targetTextField)
        {
            this.markX = this.targetTextField.width/2;
            this.markY = this.targetTextField.height/2 - (this.adjustToScale(55)*this.multipleOfDefaultFontSize);
            this.padding = this.adjustToScale(26)*this.multipleOfDefaultFontSize;
            if(this.targetTextField.text == "i")
            {
                this.padding = this.adjustToScale(2)*this.multipleOfDefaultFontSize;
                this.markY = this.targetTextField.height/2 - (this.adjustToScale(98)*this.multipleOfDefaultFontSize);
            }
            this.parentTarget = this.targetTextField;
            this.targetTextFieldStyle = this.targetTextField.style;
            this.markWidth = 55*this.multipleOfDefaultFontSize;
            this.markHeight = this.adjustToScale(18)*this.multipleOfDefaultFontSize;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const graphicsW = this.markWidth;
        const divisorW = 5;
        let divisorH = 1;
        if(this.targetTextField)
        {
            divisorH = 1.4;
        }

        const mark = new Graphics();
        mark.moveTo(0, 0);
        mark.bezierCurveTo(graphicsW/divisorW, this.markHeight*divisorH, graphicsW-(graphicsW/divisorW), this.markHeight*divisorH, graphicsW, 0);
        //mark.lineStyle({width:this.strokeThickness, color:color, cap:LINE_CAP.ROUND});
        mark.stroke({color:color, width:this.strokeThickness, cap:"round"});
        this.addChild(mark);
        //mark.scale.set(this.textScale);
        //mark.cacheAsBitmap = true;
        mark.visible = visible;
        this.addChild(mark);
        return mark;
    }


    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }
}